import axios from "axios";
const getHeaders = (token) => {
  return {
    "Content-Type": "application/json",
    "authentication-token": `${token}`,
  };
};
// GET METHOD
const _get = async (url, token = "") => {
  try {
    const headers = getHeaders(token);
    const res = await axios.get(url, { headers });
    return { status: res.status, data: res.data };
  } catch (error) {
    return { status: error.response?.status, message: error.message };
  }
};
// POST METHOD
const _post = async (url, formData, directToken = "") => {
  try {
    const headers = getHeaders(directToken);

    const requestConfig = {
      method: "post",
      url: url,
      headers: headers,
      data: formData,
    };
    const res = await axios.post(url, formData, { headers });
    console.log("Token", res);
    return { status: res.status, data: res.data };
  } catch (error) {
    return { status: error.response?.status, message: error.message };
  }
};
// DELETE METHOD
const _delete = async (url, directToken = "") => {
  try {
    const headers = getHeaders(directToken);
    const requestConfig = {
      method: "delete",
      url: url,
      headers: headers,
    };
    const res = await axios(requestConfig);
    return { status: res.status, data: res.data };
  } catch (error) {
    return { status: error.response?.status, message: error.message };
  }
};
// PUT METHOD
const _put = async (url, formData, directToken = "") => {
  try {
    const headers = getHeaders(directToken);
    const requestConfig = {
      method: "put",
      url: url,
      headers: headers,
      data: formData,
    };
    const res = await axios(requestConfig);
    return { status: res.status, data: res.data };
  } catch (error) {
    return { status: error.response?.status, message: error.message };
  }
};
export { _get, _post, _delete, _put };
